import React, { CSSProperties, ReactNode } from 'react'
import { CenterFlex, ColFlex, ExpRowFlex, RowFlex } from './Misc'
import AvatarClient from './LiveAvatarClient'
import { BaseLabel, baseTextSize, CapsuleInput, DonutChart, getThemePalette, largeGap, bigGap, palette, palettePoste, RectButton, RectInput, standardGap, standardPadding, smallGap } from '../Misc/style'
import { ChatHistory, ChatHistoryBox, ChatHistoryBoxWithContentOverlay, ChatMessage, MessageContent } from './ChatHistoryBox'
import { isMobile } from 'react-device-detect'
// import { LanguageSelector } from './LanguageSelector'
import { ProxyLang, enabledProxyLanguages, getAzureVoice, getDefaultProxyLanguage, getProxyLanguageLabel, isEnabledProxyLanguage, makeGetLocString } from '../Localization/locDef'
import { ProxyLoginResp, ProxyMessageData, decodeProxyMessageResponse, requestProxyLogin, sendMessageToProxy } from '../Misc/utils'
import { ttsPlayer, setTtsMuteAudio, stopTtsPlay, sttFromMic, tts } from '../Misc/azureSpeech'
import { OverlayScreen } from './OverlayScreen'
import { AppConfig } from '../configDef'
import { Avatar3DComponent, avatar3dStartTalking, avatar3dStopTalking, avatar3dVisemeReceived } from './Avatar3DComponent'
import { AppDispatchContext, AppStateContext, DoLoginContext } from '../App'
import { PieChart } from 'react-minimal-pie-chart'
import { contentPadding as baseScreenContentPadding } from './BaseScreen'
import { Tooltip } from 'react-tooltip'
import { debounce } from 'lodash'; // Install lodash if not already installed


// porcata per evitare chiamate multiple quando si aggiorna la pagina
let initialMessageSent = false

const getSessionIdFromUrlStr = (urlStr: string) => {
    const url = new URL(window.location.href)
    return url.searchParams.get('id')
}
const sessionIdFromUrl = getSessionIdFromUrlStr(window.location.href)

export const MainScreen = () => {
    const appState = React.useContext(AppStateContext)
    const dispatch = React.useContext(AppDispatchContext)
    const doLogin = React.useContext(DoLoginContext);

    const [language, setLanguage] = React.useState(getDefaultProxyLanguage())
    const [userTextInput, setUserTextInput] = React.useState('')
    const [chatHistory, setChatHistory] = React.useState<ChatHistory>([])
    const chatHistoryRef = React.useRef<ChatHistory>([])
    const [talking, setTalking] = React.useState(false)
    const [micState, setMicState] = React.useState<'inactive' | 'starting' | 'listening'>('inactive')
    const [overlayContent, setOverlayContent] = React.useState<null | MessageContent>(null)

    const [proxyLoginResp, setProxyLoginResp] = React.useState<ProxyLoginResp | null>(null)
    // const setProxyLoginResp = (loginResp: ProxyLoginResp) => {
    //     if (appState._tag === 'logged_in') {
    //         dispatch({_tag: 'setWholeState', state: {...appState, proxyLoginResp: loginResp}})
    //     }
    // }

    const [firstInteractionDone, setFirstInteractionDone] = React.useState(true)
    const [avatarLoadingEnded, setAvatarLoadingEnded] = React.useState(false)
    const [heyGenAvatarReady, setHeyGenAvatarReady] = React.useState(false)
    const [showAvatar, setShowAvatar] = React.useState(true)
    const [muteAudio, setMuteAudio] = React.useState(false)
    const [isPauseOn, setIsPauseOn] = React.useState(false)
    const [isLandscape, setIsLandscape] = React.useState(window.innerWidth > window.innerHeight);

    // Add ref for HeyGen Avatar
    const avatarRef = React.useRef<any>(null);

    const currentCourseName = appState._tag === 'logged_in' && 'courseName' in appState.screen ? appState.screen.courseName : 'dummy'
    const currentLessonName = appState._tag === 'logged_in' && 'courseName' in appState.screen ? appState.screen.lessonName : 'dummy'

    // const [lastLesson, setLastLesson] = React.useState<string | undefined>(undefined)
    // const setLastLesson = (lesson: string) => {
    //     if (appState._tag === 'logged_in' && appState.screen._tag === 'course_lessons') {
    //         dispatch({_tag: 'setCurrentLesson', lesson: lesson})
    //     }
    // }

    const ls = makeGetLocString(language)
    const languageSelectorLabel = language === ProxyLang.ITA ? 'Lingua conversazione' : 'Conversation language'

    // const isScreenShown = appState._tag === 'logged_in' && appState.avatarType !== null// && appState.screen._tag === 'course_lessons'
    // const isScreenShownRef = React.useRef<boolean>(isScreenShown)
    // isScreenShownRef.current = isScreenShown

    // // roba audio quando schermata è nascosta
    // React.useEffect(() => {
    //     if (!isScreenShown) {
    //         stopTtsPlay()
    //     }
    // }, [isScreenShown])

    // roba chat history quando cambia il corso
    React.useEffect(() => {
        chatHistoryRef.current = []
        setChatHistory(chatHistoryRef.current)
    }, [currentCourseName])

    const loginRef = React.useRef(false);

    React.useEffect(() => {
        if (!loginRef.current) {
            loginRef.current = true;
            doLogin("Teo", "pas2021!");
        }
    },[])

    // roba resize
    const useWindowSize = () => {
        const [size, setSize] = React.useState({ w: window.innerWidth, h: window.innerHeight });
    
        React.useEffect(() => {
            const handleResize = debounce(() => {
                const width = window.innerWidth;
                const height = window.innerHeight;
                setSize({ w: window.innerWidth, h: window.innerHeight });
                setIsLandscape(width > height); // Update landscape state
                // console.log("resize event fired", { w: window.innerWidth, h: window.innerHeight });
            }, 700);
    
            window.addEventListener('resize', handleResize);
            window.screen.orientation.addEventListener('change', handleResize);
    
            return () => {
                window.removeEventListener('resize', handleResize);
                window.screen.orientation.removeEventListener('change', handleResize);
            };
        }, []);
    
        return { size, isLandscape };
    };

    const innerSize = useWindowSize();

    React.useEffect(() => {
        // console.log("Initial size:", innerSize);
    }, [innerSize]);

    

    // roba idle
    /*const idleTimeoutRef = React.useRef<undefined | ReturnType<typeof setTimeout>>(undefined)
    React.useEffect(() => {
        if (AppConfig.idleTimeoutSeconds > 0) {
            if (!talking) {
                if (idleTimeoutRef.current === undefined) {
                    idleTimeoutRef.current = setTimeout(() => {
                        sendMessage({function: 'question', lesson: lastLesson, messageText: 'client idle state'}, 'automatic')
                    }, AppConfig.idleTimeoutSeconds * 1000)
                }
            } else {
                clearTimeout(idleTimeoutRef.current)
                idleTimeoutRef.current = undefined
            }
        }
    }, [talking])*/

    // roba messaggio iniziale
    React.useEffect(() => {
        if (avatarLoadingEnded && appState._tag === 'logged_in' && appState.username !== '') {
            if (firstInteractionDone && !initialMessageSent) {
                // Message will be sent after sendMessage is defined
            }
        }
    }, [avatarLoadingEnded, appState, currentCourseName, firstInteractionDone])

    // mute
    React.useEffect(() => {
        setTtsMuteAudio(muteAudio)
    }, [muteAudio])

    // Initialize HeyGen avatar session
    React.useEffect(() => {
        if (avatarLoadingEnded && showAvatar) {
            
        }
    }, [avatarLoadingEnded, showAvatar])

    const sendToVampServerWithAuth = React.useCallback(async (data: ProxyMessageData) => {
        if (appState._tag !== 'logged_in') throw new Error()

        // i setter dello stato sono asincroni, quindi mette il token in questa variabile per usarlo subito
        // let loginResp: ProxyLoginResp
        // if (appState.proxyLoginResp === null) {
            // console.log("getting access token and session id")
            // loginResp = await requestProxyLogin("Teo", "pas2021!", AppConfig.proxyUrl)
            // setProxyLoginResp(loginResp)
        // } else {
        //     loginResp = appState.proxyLoginResp
        // }
        if (appState.proxyLoginResp) {
            const sessionId = sessionIdFromUrl ?? appState.proxyLoginResp.session_id
            try {
                console.log("appState:", appState.username)
                return await sendMessageToProxy(AppConfig.proxyUrl, appState.username, sessionId, language, appState.proxyLoginResp.access_token, data)
            } catch (e) {
                throw new Error("sendToProxyServer failed: " + e)
                // console.log("sendToProxyServer failed, trying to redo login")
                // loginResp = await requestProxyLogin(appState.username, appState.password, AppConfig.proxyUrl)
                // setProxyLoginResp(loginResp)
                // return await sendMessageToProxy(AppConfig.proxyUrl, appState.username, sessionId, language, loginResp.access_token, data)
            }
        } else {
            throw new Error("could not get access token")
        }
    }, [appState, language])

    const sendMessage = React.useCallback(async (data: ProxyMessageData, source: 'automatic' | 'text' | 'speech') => {
        // console.log("sending message to AI Engine...", data);
        // if (!isScreenShownRef.current) return

        if (source !== 'automatic') {
            chatHistoryRef.current = [...chatHistoryRef.current, {direction: 'sent', contents: [{type: 'text', text: data.messageText}]}]
            setChatHistory(chatHistoryRef.current)
        }

        // Add the "thinking..." placeholder message
    const thinkingMessageIndex = chatHistoryRef.current.length;
        chatHistoryRef.current = [
            ...chatHistoryRef.current,
            {
                direction: 'received', 
                contents: [{type: 'text', text: '...'}],
            }
        ]
        setChatHistory(chatHistoryRef.current)

        const vampResp = await sendToVampServerWithAuth(data)

        // console.log("isScreenShown:" + isScreenShownRef.current)
        // if (!isScreenShownRef.current) return

        // Remove the thinking message from history by its index
        chatHistoryRef.current = chatHistoryRef.current.filter((_, index) => index !== thinkingMessageIndex)


        const decodedResp = decodeProxyMessageResponse(vampResp)
        if (decodedResp)
        {
            // imposta la lesson, se è arrivata
            // if (decodedResp.lesson !== undefined) {
            //     setLastLesson(decodedResp.lesson)
            // }

            // imposta la percentuale della lesson, se è arrivata
            if (decodedResp.lessonPercentage !== undefined && currentCourseName !== null && decodedResp.lesson) {
                dispatch({_tag: 'setLessonPercentage', course: currentCourseName, lesson: decodedResp.lesson, percentage: decodedResp.lessonPercentage, setNextIfCompleted: true})
            }

            const imageContents: MessageContent[] = Array.isArray(decodedResp.image) && decodedResp.image.length > 0
                            ? decodedResp.image.filter(url => url !== '').map(url => ({ type: 'image', url }))
                            : []
            const textContents: MessageContent[] = decodedResp.readableText.filter(t => t !== '').map(t => ({type: 'text', text: t}))
            chatHistoryRef.current = [
                ...chatHistoryRef.current,
                {direction: 'received', contents: [...imageContents, ...textContents], ttsText: decodedResp.ttsText}, 
            ]
            setChatHistory(chatHistoryRef.current)
            console.log("received response from engine, sending to tts")
            console.log(decodedResp)
            
            // Send text to HeyGen Avatar for lip-sync
            if (avatarRef.current && decodedResp.ttsText) {
                avatarRef.current.repeat(decodedResp.ttsText);
            }
            
                // tts(
                //     decodedResp.ttsText,
                //     getAzureVoice(language).lang,
                //     getAzureVoice(language).voice,
                //     () => {
                //         setTalking(true)
                //         avatar3dStartTalking()
                //     },
                //     () => {
                //         setTalking(false)
                //         avatar3dStopTalking()
                //         // Start the timer after the avatar stops talking
                //         // setTimeout(() => {
                //         //     console.log("sending automatic message")
                //         //     sendMessage(
                //         //         { function: 'question', course: currentCourseName, lesson: undefined, messageText: "ciao" },
                //         //         'automatic'
                //         //     );
                //         // }, 300000); // 60000 ms = 1 minute
                //     },
                //     (_s, e) => { 
                //         avatar3dVisemeReceived(e);
                //     //     if (isPauseOn) {
                //     //         avatar3dStopTalking();
                //     //         if (ttsPlayer) {
                //     //         ttsPlayer.pause();
                //     //         }
                //     //   }
                      
                //     }
                // )
            
        }
    }, [chatHistoryRef, setChatHistory, dispatch, currentCourseName, language, sendToVampServerWithAuth])

    // Send automatic initial message when conditions are met
    React.useEffect(() => {
        if (avatarLoadingEnded && heyGenAvatarReady && appState._tag === 'logged_in' && appState.username !== '' && firstInteractionDone && !initialMessageSent) {
            sendMessage({function: 'question', course: currentCourseName, lesson: undefined, messageText: ls('autoGreeting')}, 'automatic')
            initialMessageSent = true
        }
    }, [avatarLoadingEnded, heyGenAvatarReady, appState, currentCourseName, firstInteractionDone, ls, sendMessage])

    // const pauseContinueTalking = () => {
    //     if (!isPauseOn) {
    //         avatar3dStopTalking();
    //         setTalking(false)
    //         stopTtsPlay()
    //     } else if (isPauseOn) {
    //         tts(
    //             chatHistory[chatHistory.length-1].ttsText || '',
    //             getAzureVoice(language).lang,
    //             // "en-US-AvaMultilingualNeural",
    //             getAzureVoice(language).voice,
    //             () => {
    //                 setTalking(true)
    //                 avatar3dStartTalking()
    //             },
    //             () => {
    //                 setTalking(false)
    //                 avatar3dStopTalking()
    //             },
    //             (_s, e) => avatar3dVisemeReceived(e)
    //         );
    //     }
    // }
    const themePalette = getThemePalette(appState)
    const theme = appState._tag === 'logged_in' ? appState.theme : 'light'

    const RoundButton = (p: {onPress: () => void, iconName: string, barred: boolean, containerStyle?: CSSProperties, tooltip?: string}) =>
        <CenterFlex tooltip={p.tooltip} onPress={p.onPress} hoverBgColor={themePalette.buttonBgHovered} style={{width: buttonHeight, height: buttonHeight, borderRadius: buttonHeight, borderWidth: '0.5px', borderStyle: 'solid', borderColor:themePalette.buttonBorder, backgroundColor: themePalette.mainButtonBg, ...p.containerStyle}}>
            <img alt='button-icon' src={'images/icon_' + p.iconName + (theme === 'light' ? '' : '') + '.svg'} style={{height: '60%'}} />
            <img alt='bar' src={'images/icon_bar' + (theme === 'light' ? '' : '_d') + '.svg'} style={{position: 'absolute', height: '100%', zIndex: 1, display: p.barred ? 'flex' : 'none', pointerEvents: 'none'}} />
        </CenterFlex>
    
    const showSendInstedOfMic = userTextInput !== ''

    const micButtonHoverBg = micState === 'inactive' ? palette.buttonBgHovered : themePalette.mainButtonBg

    const buttonHeight = '4.5vh'//'calc(min(4em, 12vw, 12vh))'
    const micButtonHeight = '4.5vh'
    const micButtonMargin = '2vh'
    const languageSelector = (
        <label style={{display: 'flex', alignItems: 'center', gap: '0.8vh', color: themePalette.chatSentText, fontSize: '1.5vh'}}>
            {/* <span>{languageSelectorLabel}</span> */}
            <select
                aria-label={languageSelectorLabel}
                value={language}
                onChange={event => {
                    const nextLanguage = event.target.value
                    if (isEnabledProxyLanguage(nextLanguage)) {
                        setLanguage(nextLanguage)
                    }
                }}
                style={{
                    height: '4.5vh',
                    minWidth: '8vh',
                    borderRadius: '999px',
                    border: `0.15vh solid ${themePalette.buttonBorder}`,
                    backgroundColor: themePalette.inputBg,
                    color: themePalette.chatSentText,
                    paddingLeft: '1vh',
                    paddingRight: '1vh',
                    fontSize: '1.5vh',
                    outline: 'none',
                    cursor: 'pointer',
                }}
            >
                {enabledProxyLanguages.map(optionLanguage =>
                    <option key={optionLanguage} value={optionLanguage}>
                        {getProxyLanguageLabel(optionLanguage)}
                    </option>
                )}
            </select>
        </label>
    )
    const inputBar = (style?: CSSProperties) => {
        return (
            <RowFlex style={{...style, alignSelf: 'stretch', alignItems: 'center', borderRadius: buttonHeight, gap: '1.2vh', paddingRight: '1.2vh', boxSizing: 'border-box'}}>
                {languageSelector}
                <CapsuleInput
                    style={{
                        flex: 1,
                        backgroundColor: themePalette.inputBg,
                        borderWidth: '0.15vh',
                        borderColor: themePalette.buttonBorder,
                        fontStyle: 'italic',
                        marginRight: 0
                    }}
                    placeholder={language === ProxyLang.ITA ? "Scrivi una domanda..." : "Ask your question here..."}
                    value={userTextInput}
                    onChange={text => setUserTextInput(text)}
                    onPressEnter={() => {
                        if (userTextInput !== '' && currentCourseName !== null) {
                            sendMessage({function: 'question', course: currentCourseName, lesson: undefined, messageText: userTextInput}, 'text')
                            setUserTextInput('')
                        }
                    }}
                />
                <div style={{
                    position: 'relative',
                    height: micButtonHeight,
                    width: buttonHeight,
                    marginLeft: '1.2vh',
                    borderRadius: buttonHeight,
                    zIndex: 15,
                    backgroundColor: 'transparent',
                    overflow: 'visible',
                }}>
                    <CenterFlex
                        style={{height: '100%', width: '100%', borderRadius: buttonHeight}}
                        hoverBgColor={micButtonHoverBg}
                        onPress={() => {
                            if (userTextInput !== '') {
                                sendMessage({function: 'question', course: currentCourseName, lesson: undefined, messageText: userTextInput}, 'text')
                                setUserTextInput('')
                            } else {
                                if (micState === 'inactive') {
                                    setMicState('starting')
                                    sttFromMic(getAzureVoice(language).lang, (recEvent) => {
                                        if (recEvent.type === 'starting') {
                                            // niente perchè micState è già in starting
                                        } else if (recEvent.type === 'started') {
                                            setMicState('listening')
                                        } else if (recEvent.type === 'ended') {
                                            const resString = recEvent.result
                                            if (resString !== null && currentCourseName !== null) {
                                                sendMessage({function: 'question', course: currentCourseName, lesson: undefined, messageText: resString}, 'speech')
                                            } else {
                                                // console.log("nothing recognized")
                                            }
                                            setMicState('inactive')
                                        } else {
                                            throw new Error()
                                        }
                                    })
                                }
                            }
                        }}
                    >
                        {/* Show send icon if text is present, otherwise show mic icon and active states */}
                        <img alt='send' src={'images/paperplane.png'} style={{width: '65%', display: userTextInput !== '' ? 'flex' : 'none'}} />
                    </CenterFlex>
                    {/* Unified mic animation container */}
                    {userTextInput === '' && (micState === 'starting' || micState === 'listening') && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            borderRadius: buttonHeight,
                            zIndex: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            background: 'transparent',
                        }}>
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                webkit-playsinline="true"
                                controls={false}
                                controlsList="nodownload nofullscreen noremoteplayback"
                                style={{
                                    position: 'absolute',
                                    height: '150%',
                                    width: '150%',
                                    objectFit: 'cover',
                                    borderRadius: buttonHeight,
                                    pointerEvents: 'none',
                                    background: 'transparent',
                                }}
                                src="images/MicActive.mp4"
                            />
                        </div>
                    )}
                    {/* Mic background and icon container */}
                    {userTextInput === '' && micState === 'inactive' && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            borderRadius: buttonHeight,
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            background: 'transparent',
                        }}>
                            <img 
                                alt='mic-background' 
                                src={'images/MicBackground.png'} 
                                style={{
                                    position: 'absolute',
                                    height: '150%', 
                                    width: '150%',
                                    objectFit: 'cover',
                                    borderRadius: buttonHeight,
                                }} 
                            />
                            <img 
                                alt='mic' 
                                src='images/Mic.svg'
                                style={{
                                    height: '80%', 
                                    position: 'relative',
                                    zIndex: 2,
                                    borderRadius: buttonHeight,
                                }} 
                            />
                        </div>
                    )}
                </div>
            </RowFlex>
        )
    }

    const onChatContentPress = (content: MessageContent) => {
        if (content.type === 'pdf' || content.type === 'image') {
            setOverlayContent(content)

            window.history.pushState({}, 'overlay', null)
            window.addEventListener('popstate', function popOverlay() {
                setOverlayContent(null)
                window.removeEventListener('popstate', popOverlay);
            })
        }
    }

    /*const lessons = appState._tag === 'logged_in' && currentCourseName !== null ? appState.coursePercentages[currentCourseName] : {}
    const lessonCharts = Object.entries(lessons).toSorted((a, b) => a[1].ordinal - b[1].ordinal).map(([lessonName, lessonObj]) => {
        const lessonPercent = lessonObj.percent
        return <DonutChart key={lessonName} label={lessonName} percent={lessonPercent} />
    })*/

    const screenBgStyle = {
        backgroundImage: 'url(images/minimal-reception.jpg)', 
        backgroundSize: 'cover', 
        backgroundPosition: 'center',
        backgroundColor: themePalette.mainBg
    }
    const standardRadius = '5vh'
    return (
        <ColFlex expand style={{/* minHeight: innerSize.h, height: innerSize.h,*/fontSize: baseTextSize, backgroundColor: themePalette.mainBg, padding: standardPadding, paddingTop: 0, position: 'relative', overflow: 'hidden'}}>
            {/* Optional overlay to ensure content readability */}
            <div 
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'rgba(0, 0, 0, 0.1)', // Light overlay to ensure content readability
                    zIndex: 2
                }}
            />
            
            {/* loading overlay */}
            {!avatarLoadingEnded &&
                <div style={{position: 'absolute', inset: 0, backgroundColor: 'black', color: 'white', zIndex: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <video 
                        autoPlay 
                        loop 
                        muted 
                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                        src="images/LoadingAnimation.mp4"
                    >
                        {/* Fallback for browsers that don't support the video */}
                        <img alt="loading" src='images/loading.gif' style={{justifySelf: 'center', alignSelf: 'center', width: '6vh'}} />
                    </video>
                </div>
            }

            <RowFlex expand style={{gap: 0, position: 'relative', zIndex: 10}}>
                <ColFlex style={{flex: isLandscape ? 1 : 1, paddingLeft: isLandscape ? 200: '', paddingRight: isLandscape ? 200 : '', alignItems: 'center', justifyContent: 'center', gap: standardGap, borderRadius: 0, overflow: 'hidden'}}>
                    <CenterFlex expand style={{borderRadius: 0, overflow: 'hidden', position: 'relative'}}>
                    <div style={{display: showAvatar ? 'block' : 'none', position: 'absolute', inset: 0}}>
                        {/* <Avatar3DComponent key={isLandscape ? 'landscape' : 'portrait'} avatarType={appState._tag === 'logged_in' ? appState.avatarType : null} onLoadingEnded={() => setAvatarLoadingEnded(true)} avatarBackgroundColor={themePalette.mainBg} /> */}
                        {/* <Avatar3DComponent key={isLandscape ? 'landscape' : 'portrait'} onLoadingEnded={() => setAvatarLoadingEnded(true)} />  */}
                        {/* HeyGen Avatar will be rendered here */}
                        {React.createElement(AvatarClient as any, {
                            ref: avatarRef,
                            azureLanguage: getAzureVoice(language).lang,
                            azureVoice: getAzureVoice(language).voice,
                            onAvatarReady: () => {
                                setHeyGenAvatarReady(true);
                                setAvatarLoadingEnded(true);
                            }
                        })}
                    </div>
                    {/* Removed fallback image since it doesn't exist and HeyGen component now handles session expiry */}
                    
                    {/* Chat Overlay */}
                    <div style={{
                        position: 'absolute',
                        left: '25px',
                        right: '1px',
                        bottom: '1vh', // Start just above the mic button area
                        backgroundColor: 'transparent', // Semi-transparent background
                        borderRadius: '15px',
                        backdropFilter: 'blur(1x)',
                        // border: '1px solid rgba(255, 255, 255, 0.2)',
                        zIndex: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '15px',
                        maxHeight: '25vh', // Half of typical avatar div height
                        height: '25vh', // Fixed height for consistency
                        pointerEvents: 'auto'
                    }}>
                        <div style={{
                            flex: 1,
                            overflow: 'hidden',
                            borderRadius: '10px',
                            position: 'relative'
                        }}>
                            {/* Top fade effect */}
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '30px',
                                background: `linear-gradient(to bottom, ${themePalette.mainBg} 0%, ${themePalette.mainBg}80 30%, transparent 80%)`,
                                borderRadius: '10px 10px 0 0',
                                zIndex: 1,
                                pointerEvents: 'none'
                            }} />
                            <ChatHistoryBoxWithContentOverlay chatHistory={chatHistory} />
                        </div>
                    </div>
                    </CenterFlex>
                    {inputBar()}
                    <RowFlex style={{gap: isLandscape ? bigGap : largeGap, padding: `${smallGap}`}}>
                        <Tooltip id="tooltip" style={{fontSize: '1.0rem', zIndex: 10}} />
                        {/* <RoundButton iconName='theme' barred={false} onPress={() => dispatch({_tag: 'switchTheme'})} tooltip='Layout chiaro/scuro' /> */}
                        {/* { isLandscape ? <RoundButton iconName='avatar' barred={!showAvatar} onPress={() => setShowAvatar(p => !p)} tooltip='Attiva/disattiva avatar' /> : null } */}
                        {/* <RoundButton iconName='mute' barred={muteAudio} onPress={() => setMuteAudio(p => !p)} tooltip='Attiva/disattiva audio' /> */}
                        {/* { isLandscape ? <RoundButton iconName={isPauseOn ? 'play' : 'pause'} barred={false} tooltip='Play/Pause audio'
                            // iconPlaceholder={isPauseOn ? 'Play' : 'Pause'} 
                            onPress={() => {
                                setIsPauseOn(prev => !prev);
                                pauseContinueTalking();
                                
                            }} 
                        /> : null } */}
                    </RowFlex>
                </ColFlex>
                {/* {isLandscape ? <ColFlex style={{flex: 0.30, alignItems: 'right', backgroundColor: '#00000000', gap: standardGap}}>
                    <CenterFlex style={{flex: 1, borderRadius: 0, overflow: 'hidden'}}>
                        <ChatHistoryBoxWithContentOverlay chatHistory={chatHistory} />
                    </CenterFlex>
                    
                    {inputBar()}
                </ColFlex> : null } */}
                
                {/* First interaction overlay - positioned to work with both landscape and portrait modes */}
                {!firstInteractionDone &&
                    <CenterFlex
                        style={{
                            position: 'absolute', 
                            inset: 0, 
                            left: isLandscape ? '5vh' : '0', 
                            backgroundColor: '#000000aa', 
                            fontSize: '4vh', 
                            color: themePalette.chatSentText,
                            zIndex: 20
                        }}
                        onPress={() => setFirstInteractionDone(true)}
                    >
                        {ls('pressToStart')}
                    </CenterFlex>
                }
            </RowFlex>
            {/*overlayContent && <OverlayScreen horizontalLayout={isHorizontalLayout()} content={{type: 'pdf', url: 'documents/paper2.pdf'}} onClosePress={() => setOverlayContent(null)} containerStyle={{zIndex: 20}} />*/}
        </ColFlex>
    )
}